import React, { useState } from 'react';
import { Typography, Input, Button } from '@material-tailwind/react';

export const OrderForm = ({ onSubmit, loading, loaderColor }) => {
    const [localFormData, setLocalFormData] = useState({
        name: '',
        email: '',
        postcode: '',
        deliveryLocation: ''
    });

    const handleLocalInput = (e) => {
        const { name, value } = e.target;
        setLocalFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLocalSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, localFormData);
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center p-4">
                <div className="loader-dots m-4">
                    <div className="loader-dot" style={{ backgroundColor: loaderColor }}></div>
                    <div className="loader-dot" style={{ backgroundColor: loaderColor }}></div>
                    <div className="loader-dot" style={{ backgroundColor: loaderColor }}></div>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleLocalSubmit} className="flex flex-col gap-3 p-4 bg-white rounded-lg shadow-sm m-2">
            <Typography variant="h6" className="text-gray-900 mb-2">
                Vul uw ordergegevens in
            </Typography>
            <Input
                type="text"
                label="Naam op de order"
                name="name"
                value={localFormData.name}
                onChange={handleLocalInput}
                required
                className="w-full"
            />
            <Input
                type="email"
                label="Email"
                name="email"
                value={localFormData.email}
                onChange={handleLocalInput}
                required
                className="w-full"
            />
            <Input
                type="text"
                label="Postcode"
                name="postcode"
                value={localFormData.postcode}
                onChange={handleLocalInput}
                required
                className="w-full"
            />
            <Input
                type="text"
                label="Plaats"
                name="deliveryLocation"
                value={localFormData.deliveryLocation}
                onChange={handleLocalInput}
                required
                className="w-full"
            />
            <Button
                type="submit"
                size='lg'
                className="mt-2 bg-black text-white capitalize px-4 py-2 rounded-lg"
                disabled={loading}
            >
                Verstuur
            </Button>
        </form>
    );
};